import { render } from "./Welcome.vue?vue&type=template&id=da7c22ec&scoped=true&bindings={\"msg\":\"props\"}"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import "./Welcome.vue?vue&type=style&index=0&id=da7c22ec&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-da7c22ec"

export default script